import CardList from './cards-list';

export default CardList;
